<template>
  <div class="lucky_draw_wrap">
    <!-- <div class="header">
      <div class="center">
        <a href="javascript:void(0)" class="logo"
          ><img src="@/assets/imgs/voucherCenter/LOGO.png" alt="3dm网游加速器"
        /></a>
        <div class="flex"></div>
        <a href="javascript:void(0)" v-if="!token" class="btn" @click="openLoginPage"
          >登录/注册</a
        >
        <div v-else class="personal">
          <el-dropdown
            class="dropdown-toggle dropdown-user"
            trigger="click"
            placement="bottom-start"
          >
            <div
              class="dropdown-toggle dropdown-user"
              id="dropdownMenu1"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <div class="user-logo">
                <img class="avator" :src="userInfo.head_image_url" alt />
              </div>
              <ul class="user-right">
                <li class="login-phone">{{userInfo.nick_name || userInfo.user_phone}}</li>
                <li class="login-date">VIP剩余{{userInfo.remain_accelerate_time || '0天'}}</li>
              </ul>
            </div>
            <el-dropdown-menu slot="dropdown" class="dropdown-menu">
              <el-dropdown-item>
                <a id="logout" @click="logout">
                  <i class="icon icon-logout"></i> 退出登录
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div> -->
    <div class="recharge_wrap">
      <div class="bg1">
        <img src="@/assets/imgs/luckyDraw/bg_elment.png" alt="" />
      </div>
      <div class="bg2">
        <img src="@/assets/imgs/luckyDraw/bg_circle.png" alt="" />
      </div>
      <div class="main_img">
        <img class="head" src="@/assets/imgs/luckyDraw/head.png" alt="" />
        <img class="btn" src="@/assets/imgs/luckyDraw/btn.png" alt="" />
      </div>
    </div>
    <div class="pack_wrap">
      <div class="login_wrap">
        <div v-if="!token">您好, 请 [ <span class="login_btn" @click="openLoginPage">登录</span> / <span class="login_btn" @click="openLoginPage">注册</span> ] </div>
        <div v-else class="personal">
          <div>您好，用户【 <span class="login_btn">{{userInfo.nick_name || userInfo.user_phone}}</span> 】 <span class="login_btn" @click="logout">退出</span></div>
          <div class="userinfo">
            <img class="avator" :src="userInfo.head_image_url" alt />
            <span>VIP剩余{{userInfo.remain_accelerate_time || '0天'}}</span>
          </div>
        </div>
      </div>
      <div class="active_login_info">
        <span class="title">活动一</span>
        <span class="content">登录即可免费获得一次抽奖机会</span>
        <i class="el-icon-success getIcon" v-if="token" style="color: #67C23A"></i>
      </div>
      <div class="active_recharge_info">
        <span class="title">活动二</span>
        <span class="content">充值相应会员套餐额外获得相应抽奖机会</span>
      </div>
      <div class="product_list">
        <div class="list_item" v-for="item in activeProduct" :key="item.id">
          <div class="card">
            <span class="title">{{ item.info.product_name }}</span>
            <span class="average"
              >{{
                (item.info.product_price / item.info.hour).toFixed(2)
              }}
              元/小时</span
            >
            <div class="price_info info">
              年末狂欢价：
              <span class="price">{{ getNowPrice(item.info) }}</span
              ><span class="unit">元</span>
            </div>
            <!-- <div class="origin info">
              &nbsp;&nbsp;&nbsp;原价：<span>{{ item.info.origin_price }}</span
              ><span class="unit">元</span>&nbsp;&nbsp;&nbsp;
            </div> -->
            <div class="purchase" @click="purchase(item)">立即购买</div>
          </div>
          <div class="welfare info">
            购买后可获得<span>{{ item.draw_limit }}次</span>抽奖机会
          </div>
        </div>
      </div>
    </div>
    <div class="lucky_wrap">
      <div class="draw_wrap">
        <div class="left">
          <LuckyGrid
            ref="myLucky"
            width="400px"
            height="400px"
            :prizes="prizes"
            :blocks="blocks"
            :buttons="buttons"
            :defaultStyle='defaultStyle'
            :defaultConfig='defaultConfig'
            @start="startCallback"
            @end="endCallback"
          />
        </div>
        <div class="right">
          <div class="list_header">中奖名单</div>
          <vue-seamless-scroll :data="records" class="seamless-warp" :step='1'>
            <ul class="item">
                <li v-for="(item,index) in records" :key="index">
                  <span>恭喜<span class="info">{{item.user_name ? formatName(item.user_name) : formatName(item.user_phone,'phone')}}</span>获得奖品<span class="info">{{item.prize_name}}</span></span>
                </li>
            </ul>
          </vue-seamless-scroll>
          <div class="list_footer" @click="openLayerRecord">查看中奖记录</div>
        </div>
      </div>
    </div>
    <div class="rule_wrap">
      <div class="title">活动规则</div>
      <div class="rule">
        <span v-html="activeInfo.description" style="white-space: pre-wrap"></span>
      </div>
    </div>

    <transition name="fade">
      <div class="layer" v-show="layerShow">
        <div class="layer-title">
          <div class="title">充值</div>
          <span class="el-icon-close" @click="closeLayer"></span>
        </div>
        <div class="layer-content">
          <div class="pay-code" @contextmenu.prevent.stop>
            <div
              class="qr-code"
              ref="qrCode"
              :class="{ loading: qrLoading }"
            ></div>
            <div class="scan" v-show="!qrLoading"></div>
            <div class="qr-loading" v-show="qrLoading"></div>
          </div>
          <div class="pay-info">
            <h5 class="sum">
              <span class="icon">¥</span>
              <span class="integer">{{ parseInt(pay_amount) }}</span>
              <span class="float">{{ getPriceFloat(pay_amount) }}</span>
            </h5>
            <span class="discount" v-if="coupon_discount>0">(券后优惠：{{coupon_discount}}元)</span>
            <h5 class="tips">
              打开{{ form.payWay | translateToName(payWays) }}扫码完成支付
            </h5>
            <div class="operate">
              <div class="payWay" :class="form.payWay == 'wx_qrcode' ? 'selected':''" @click="checkPayWay('wx_qrcode')">微信</div>
              <div class="payWay" :class="form.payWay == 'ali_qrcode' ? 'selected':''" @click="checkPayWay('ali_qrcode')">支付宝</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="layer-shadow" v-show="layerShow" @click="closeLayer"></div>

    <el-dialog
      title="中奖记录"
      :visible.sync="layerShowRecord"
      width="700px"
      custom-class="login-dialog"
      append-to-body
    >
      <el-table
        :data="userRecord"
        style="width: 100%">
        <el-table-column
          prop="prize_name"
          label="奖品"
          width="180">
        </el-table-column>
        <el-table-column
          prop="name"
          label="奖品详情"
          width="240">
          <template slot-scope="scope">
            <span>{{showPrizeDetail(scope.row)}}</span>
            <!-- <span v-if="scope.row.prize_name == '会员充值免单券' || scope.row.prize_name == '会员充值买一送一' || scope.row.prize_name == '500元游戏随心购'">请截图联系客服领取(联系方式请查看活动规则)</span>
            <span v-if="scope.row.resource_type== 'coupons' || scope.row.resource_type == 'duration_card'">已发放至账户卡券包</span> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="draw_at"
          label="中奖时间">
        </el-table-column>
      </el-table>
    </el-dialog>
    
    <!-- 登录弹窗 -->
    <el-dialog
      title="登录/注册"
      :visible.sync="showLoginDialog"
      width="528px"
      custom-class="login-dialog"
      append-to-body
    >
      <login v-if="showLoginDialog" />
    </el-dialog>

    <img class="dl_btn" src="@/assets/imgs/luckyDraw/dl.png" alt="点击下载客户端" title="点击下载客户端" @click="getWinHref">
  </div>
</template>

<script>
import { getActiveInfo, getLuckyDrawRecord, getLuckyDrawCount, startLuckyDraw, getUserRecord } from "@/api/lucky";
import {
  getVipPackages,
  getAdvanceOrder,
  getPayQrCode,
  getPayStatus,
} from "@/api/voucherCenter";
import { getCouponList } from "@/api/coupons";
import { logOut } from '@/api/user'
import { getWinDownloadUrl } from '@/api/footer'
import QRCode from "qrcodejs2";
import Login from "../login";
export default {
  components: {
    Login,
  },
  data() {
    return {
      layerShowRecord: false,
      dlUrl: '', //客户端下载地址
      timerId: null,
      qrcode: null,
      qrLoading: false,
      allCouponList: [],
      selectedItem: {},
      layerShow: false,
      lastPrice: 0,
      pay_amount: 0,
      coupon_discount: 0,
      form: {
        couponId: 0,
        payWay: "wx_qrcode",
      },
      payWays: [
        { value: "wx_qrcode", label: "微信" },
        { value: "ali_qrcode", label: "支付宝" },
      ],
      activeInfo: {}, // 充值活动信息
      loginActiveInfo: {}, // 登录活动信息
      records: [], // 活动中奖记录
      userRecord: [], // 用户中奖记录
      productList: [], // 在售套餐
      activeProduct: [],  // 活动参与套餐
      rest_count: 0, // 充值剩余抽奖次数
      login_rest_count: 0, // 登录剩余抽奖次数
      blocks: [
        { padding: "10px" },
      ],
      prizes: [
        { x: 0, y: 0,  fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF' }] },
        { x: 1, y: 0, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 2, y: 0, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 2, y: 1, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 2, y: 2, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 1, y: 2, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 0, y: 2, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
        { x: 0, y: 1, fonts: [{ text: "暂无奖品", top: "40%", fontColor: '#FFF'  }] },
      ],
      defaultStyle: {
        background: '#6c2bd3', 
        fontSize: "12",
        borderRadius: '10px',
        wordWrap: false
      },
      defaultConfig: {
        gutter: 20
      },
    };
  },
  computed: {
    couponList() {
      const { allCouponList, selectedItem } = this;
      const now = Date.now();
      return allCouponList
        .filter((item) => {
          const supportProducts = JSON.parse(item.support_product || "[]");
          return supportProducts.some((id) => {
            // let lastPrice = this.getLastPrice(selectedItem, item)
            // lastPrice > 0 &&
            return (
              parseInt(id) === selectedItem.info.id &&
              now > new Date(item.valid_begin_time).getTime() &&
              now < new Date(item.valid_end_time).getTime()
            );
          });
        })
        .map((it) => ({
          ...it,
          label:
            (it.type === 2 ? `￥${it.discount}` : `${it.discount_rate}折`) +
            `——${it.name}`,
        }));
    },
    token() {
      return this.$store.getters.token
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isVip() {
      return this.userInfo.is_vip;
    },
    showLoginDialog: {
      get() {
        return this.$store.state.app.showLoginDialog;
      },
      set(show) {
        this.$store.commit("app/setShowLogin", show);
      },
    },
    buttons() {
      return [
        {
          x: 1,
          y: 1,
          background: "#fb7971",
          fonts: [
            { text: "点击抽奖", top: "30%",fontColor: '#FFF',fontSize: '20px',fontWeight: 600 },
            { text: `剩余抽奖次数: ${this.rest_count + this.login_rest_count}次`, top: "55%",fontColor: '#FFF',fontSize: '12px' }
          ],
          imgs:[{src: 'http://dl.js.3dmjiasu.com/upload/res/1589925732967321600.png',width: '120px',height: '120px'}]
        },
      ]
    }
  },
  watch: {
    token(newVal,oldVal){
      if(newVal != oldVal){
        this.getCoupons()
        this.getActive()
      }
    }
  },
  created() {
    // this.getProductList()
    const { token } = this.$route.query
    if(token){
      this.$store.dispatch('user/swapToken',token).then(() =>{
        this.$router.push('/luckyDrawLogin')
      })
    }
    this.getActive();
    if(this.token){
      this.getCoupons()
    }
    // this.getWinHref()
    // this.getRecord()
  },
  methods: {
    // 奖品详情处理
    showPrizeDetail(row){
      let txt = ''
      let arr = ['cod19']
      if(row.resource_type == "conversion_code"){
        if(arr.includes(row.prize_name)){
          txt = '请截图联系客服领取(联系方式请查看活动规则)'
        }else{
          txt = row.resource_name
        }
      }else{
        txt = '已发放至账户卡券包'
      }
      return txt
    },
    // 昵称/手机号脱敏处理
    formatName(name,type = 'name') {
      let newStr;
      if (name.length === 2) {
          newStr = name.substr(0, 1) + '*';
      } else if (name.length > 2) {
          let char = '';
          let len = name.length - 2 > 4 ? 4 : name.length - 2
          for (let i = 0; i < len; i++) {
              char += '*';
          }
          if(type == 'phone'){
            newStr = name.substr(0, 3) + char + name.substr(-4, 4);
          }else{
            newStr = name.substr(0, 1) + char + name.substr(-1, 1);
          }
      } else {
          newStr = name;
      }
      return newStr;
    },
    // 获取客户端下载地址
    getWinHref() {
      getWinDownloadUrl({
        channel_number: process.env.VUE_APP_CHANNEL || '',
      }).then((data) => {
        if (data.success) {
          this.dlUrl = data.url
          window.open(data.url,'_self')
        }
      })
    },
    // 获取优惠券列表
    getCoupons() {
      getCouponList()
        .then(({ list }) => {
          this.allCouponList = list || [];
          // if (select)
          //   setTimeout(() => {
          //     const firstItem = this.couponList[0];
          //     this.form.couponId = firstItem ? firstItem.id : "";
          //     this.setLastPrice();
          //   });
        })
        .catch(() => {});
    },
    // 计算最终金额
    getLastPrice(item, couponObj) {
      const minPrice = 0.01;
      let nowPrice = this.getNowPrice(item);
      if (isNaN(nowPrice)) return minPrice;
      if (couponObj) {
        switch (couponObj.type) {
          case 1:
            nowPrice *= couponObj.discount_rate / 10;
            break;
          case 2:
            nowPrice -= couponObj.discount;
            break;
        }
      }
      if (nowPrice < minPrice) nowPrice = minPrice;
      return Math.round(nowPrice * 100) / 100;
    },
    setLastPrice() {
      const {
        couponList,
        form: { couponId },
      } = this;
      const couponObj = couponList.find((it) => it.id === couponId);
      this.lastPrice = this.getLastPrice(this.selectedItem, couponObj);
      console.log(this.lastPrice)
    },
    // 打开中奖记录列表
    openLayerRecord(){
      if(this.token){
        this.layerShowRecord = true
        const params = {
          page: 1,
          page_size: 100
        }
        getUserRecord(this.activeInfo.id, params).then(res =>{
          this.userRecord = res.data.list || []
          getUserRecord(this.loginActiveInfo.id,params).then(res =>{
            this.userRecord = this.userRecord.concat(res.data.list || [])
          })
        })
      }else{
        this.$confirm("请先登录您的账号！", {
          title: "提示",
        })
          .then(() => {
            this.setShowLogin();
          })
          .catch(() => {});
        return;
      }
    },
    // 关闭中奖记录列表
    closeLayerRecord(){
      this.layerShowRecord = false
    },
    checkPayWay(e){
      this.form.payWay = e
      this.createPreOrder(this.selectedItem)
    },
    // 购买
    purchase(item) {
      if (!this.token) {
        this.$confirm("请先登录您的账号！", {
          title: "提示",
        })
          .then(() => {
            this.setShowLogin();
          })
          .catch(() => {});
        return;
      }
      this.layerShow = true;
      this.selectedItem = item
      // 自动选择最优的优惠券
      let index, price
      this.couponList.forEach((it, i) => {
        const cost = this.getLastPrice(item.info, it)
        if (i === 0 || price > cost) {
          price = cost
          index = i
        }
      })
      this.form.couponId = isNaN(index) ? '' : this.couponList[index].id
      console.log(this.form)
      // this.setLastPrice()
      // console.log(item)
      this.createPreOrder(item);
    },
    // 生成预订单
    createPreOrder(item) {
      this.clearTimerId();
      const {
        // selectedItem: { id, product_name: productName },
        form: { couponId ,payWay },
      } = this;
      let param = {
        product_id: item.info.id + "", // 商品id
        product_name: item.info.product_name, // 商品名称
        order_channel: "官网", // 下单渠道.如果是客户端，请传：加速器客户端，如果是官网，请传：官网
        pay_way: payWay, // 支付方式。如果是支付宝支付，请传：ali_qrcode,如果微信支付，请传：wx_qrcode
        user_id: this.userInfo.user_id,
        coupon_id: couponId || 0,
      };
      this.qrLoading = true;
      getAdvanceOrder(param).then((data) => {
        if (data.success == true) {
          this.pay_amount = data.data.pay_amount
          this.coupon_discount = data.data.coupon_discount
          // localStorage.setItem('order_id', data.data.out_order_sn)
          // 生成二维码
          const outOrderSn = (this.outOrderSn = data.data.out_order_sn);
          this.getPayCode(outOrderSn);
          this.timerId = setInterval(this.payStatus, 3000, outOrderSn);
          // 订单状态查询
          this.payStatus(outOrderSn);
        }
      });
    },
    // 生成二维码
    getPayCode(ordersn) {
      var param = {
        out_order_sn: ordersn, //订单id
      };
      getPayQrCode(param)
        .then((res) => {
          this.qrLoading = false;
          const container = this.$refs.qrCode;
          if (this.qrcode) {
            this.qrcode.makeCode(res.url);
          } else {
            const { width, height } = container.getBoundingClientRect();
            this.qrcode = new QRCode(container, {
              text: res.url,
              width,
              height,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: 0,
            });
          }
          container.title = "";
        })
        .catch(() => {
          // this.qrLoading = false
        });
    },
    // 定时查询  订单状态查询
    payStatus(outOrderSn) {
      return new Promise((resolve, reject) => {
        getPayStatus({
          order_number: outOrderSn, //订单id
        })
          .then((data) => {
            if (data.code == 200 && data.status == "已付款") {
              this.paySuccess = true;
              this.payResultShow = true;
              setTimeout(() => {
                this.payResultShow = false;
              }, 3000);
              this.form.couponId = "";
              this.$store.dispatch("user/getUserInfo");
              this.closeLayer()
              this.$message.success('已获得抽奖次数，快去抽奖吧~')
              this.getLuckyDrawRestCount()
              resolve(true);
            } else if (data.code == 200 && data.status == "订单超时") {
              this.createPreOrder();
              resolve(false);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            this.paySuccess = false;
            this.payResultShow = true;
            setTimeout(() => {
              this.payResultShow = false;
            }, 3000);
            reject();
          });
      });
    },
    getPriceFloat(price) {
      let match = /(\.\d+)/.exec(price);
      return match ? match[0] : ".00";
    },
    clearTimerId() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },
    closeLayer() {
      this.clearTimerId();
      this.layerShow = false;
      // 重新获取优惠券
      this.getCoupons();
      // 购买的套餐有限制次数,就刷新商品列表
      if (this.selectedItem.limit_buy !== 0) {
        this.getActiveProduct();
      }
      this.outOrderSn = "";
    },
    // 登出系统
    logout() {
      logOut()
      this.rest_count = 0
      this.$store.dispatch('user/removeToken')
      window.localStorage.clear()
      if(this.$route.path === '/personal'){
        this.$router.push('/')
      }
    },
    // 点击抽奖按钮会触发star回调
    startCallback () {
      if(!this.token){
        this.$confirm("请先登录您的账号！", {
          title: "提示",
        })
          .then(() => {
            this.setShowLogin();
          })
          .catch(() => {});
        return;
      }
      if(this.rest_count + this.login_rest_count < 1) {
        return this.$message.error('抽奖次数不足，购买活动套餐可获得额外抽奖次数')
      }
      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play()
      // 登录活动有抽奖次数时，消耗登录抽奖次数，没有消耗充值抽奖次数
      let activeId = this.login_rest_count > 0 ? this.loginActiveInfo.id : this.activeInfo.id
      // 调用抽奖方法
      startLuckyDraw(activeId).then(res =>{
        let flag = true
        this.prizes.forEach((item,index) =>{
          if(item.fonts[0].text == res.data.prize_name && flag){
            this.$refs.myLucky.stop(index)
            flag = false
            setTimeout(()=>{
              this.$message.success(`恭喜获得${res.data.prize_name}`)
              this.getLuckyDrawRestCount()
            },5000)
          }
        })
      }).catch(()=>{
        this.$refs.myLucky.stop(8)
        this.$message.error('网络开小差了~请刷新页面重试')
        this.getLuckyDrawRestCount()
      })
    },
    // 抽奖结束会触发end回调
    endCallback (prize) {
      console.log(prize)
      this.getCoupons()
      this.getRecord()
    },
    // 打开登录页面
    openLoginPage() {
      this.setShowLogin();
    },
    setShowLogin(show = true) {
      this.$store.commit("app/setShowLogin", show);
    },
    // 获取活动
    getActive() {
      getActiveInfo()
        .then((res) => {
          res.data.forEach((item) => {
            if (item.type == "recharge") {
              this.activeInfo = item;
              this.dealPrizeList(item.draw_task_prizes)
              localStorage.setItem("active", JSON.stringify(item));
              this.getActiveProduct(item.draw_type_details);
              if(this.token){
                this.getLuckyDrawRestCount()
              }
            }
            if(item.type == 'login') {
              this.loginActiveInfo = item
            }
          })
          this.getRecord();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取活动信息失败！");
        });
    },
    // 奖品数据处理
    dealPrizeList(info){
      const position = [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 2 },
        { x: 0, y: 2 },
        { x: 0, y: 1 }
      ]
      this.prizes = []
      info.forEach((item,index) =>{
        let res = {...position[index],fonts: [{ text: item.prize.name, top: "70px", fontColor: '#FFF' },{ text: item.prize.description, top: "90px", fontColor: '#FF7E07', fontWeight: 600, fontSize: 14 }],imgs:[{src: item.prize.pictures[0], top: '12px',width: '70px',height: '50px',activeSrc: item.prize.pictures[1] || item.prize.pictures[0]}] }
        this.prizes.push(res)
      })
      // this.prizes = [
      //   { x: 0, y: 0, fonts: [{ text: info[0].prize.name, top: "70px", fontColor: '#FFF' },{ text: info[0].prize.description, top: "90px", fontColor: '#FF7E07', fontWeight: 600, fontSize: 14 }],imgs:[{src: info[0].prize.pictures[0], top: '12px',width: '70px',height: '50px'}] },
      //   { x: 1, y: 0, fonts: [{ text: info[1].prize.name, top: "70px", fontColor: '#FFF' },{ text: info[1].prize.description, top: "90px", fontColor: '#FF7E07', fontWeight: 600, fontSize: 14 }],imgs:[{src: info[1].prize.pictures[0], top: '12px',width: '70px',height: '50px'}] },
      //   { x: 2, y: 0, fonts: [{ text: info[2].prize.name, top: "70px", fontColor: '#FFF' },{ text: info[2].prize.description, top: "90px", fontColor: '#FF7E07', fontWeight: 600, fontSize: 14 }],imgs:[{src: info[2].prize.pictures[0], top: '12px',width: '70px',height: '50px'}] },
      //   { x: 2, y: 1, fonts: [{ text: info[3].prize.name, top: "70px", fontColor: '#FFF' },{ text: info[3].prize.description, top: "90px", fontColor: '#FF7E07', fontWeight: 600, fontSize: 14 }],imgs:[{src: info[3].prize.pictures[0], top: '12px',width: '70px',height: '50px'}] },
      //   { x: 2, y: 2, fonts: [{ text: info[4].prize.name, top: "70px", fontColor: '#FFF' },{ text: info[4].prize.description, top: "90px", fontColor: '#FF7E07', fontWeight: 600, fontSize: 14 }],imgs:[{src: info[4].prize.pictures[0], top: '12px',width: '70px',height: '50px'}] },
      //   { x: 1, y: 2, fonts: [{ text: info[5].prize.name, top: "70px", fontColor: '#FFF' },{ text: info[5].prize.description, top: "90px", fontColor: '#FF7E07', fontWeight: 600, fontSize: 14 }],imgs:[{src: info[5].prize.pictures[0], top: '12px',width: '70px',height: '50px'}] },
      //   { x: 0, y: 2, fonts: [{ text: info[6].prize.name, top: "70px", fontColor: '#FFF' },{ text: info[6].prize.description, top: "90px", fontColor: '#FF7E07', fontWeight: 600, fontSize: 14 }],imgs:[{src: info[6].prize.pictures[0], top: '12px',width: '70px',height: '50px'}] },
      //   { x: 0, y: 1, fonts: [{ text: info[7].prize.name, top: "70px", fontColor: '#FFF' },{ text: info[7].prize.description, top: "90px", fontColor: '#FF7E07', fontWeight: 600, fontSize: 14 }],imgs:[{src: info[7].prize.pictures[0], top: '12px',width: '70px',height: '50px'}] },
      // ]
    },
    // 获取抽奖记录
    getRecord() {
      const data = {
        page: 1,
        page_size: 1000,
      };
      getLuckyDrawRecord(this.activeInfo.id, data).then((res) => {
        // console.log(res)
        this.records = res.data.list || [];
        getLuckyDrawRecord(this.loginActiveInfo.id, data).then(res =>{
          this.records = this.records.concat(res.data.list || [])
          // 当抽奖数据不足50条时，塞点数据进去
          if(this.records.length < 50){
            let prizelist = ['加速器5元抵扣券', '加速器3天时长卡','加速器10天时长卡','加速器20天时长卡','加速器5折券']
            let nameList = [
              'Nami严','童','艾特一下@','heap','啊哈','GAO','慌的一批','giao','我是小啊giao','流浪pig',
              '诗','钱','cocoa', '緣來遇見妳','遇见','清风逝～','穷的很','那年暖冬','Arthur','Morgan',
              '薛定谔的喵x','双鱼仔a','SadSakura','躲鑶鍀眼睛','疯子','梦花浮萍','a小时','[bbs','風霰','2048'
            ]
            let randomPrizeIndex, randomNameIndex
            for(let i = 0; i< 50;i++){
              randomPrizeIndex = parseInt(Math.random()*5)
              randomNameIndex = parseInt(Math.random()*30)
              this.records.push({
                user_name: nameList[randomNameIndex],
                prize_name: prizelist[randomPrizeIndex]
              })
            }
            this.records.sort(()=>{
              return 0.5 - Math.random()
            })
          }
        })
      });
    },
    // 筛选抽奖套餐
    getActiveProduct(arr) {
      let result = [];
      getVipPackages({
        product_status: "在售",
        product_type: 2,
      })
        .then(({ data }) => {
          this.productList = data;
          arr.forEach((item) => {
            data.forEach((it) => {
              if (item.label == it.id) {
                item.info = it;
                result.push(item);
              }
            });
          });
          this.activeProduct = result;
        })
        .catch(() => {});
    },
    // 获取当前价格
    getNowPrice(item) {
      return this.isVip
        ? item.vip_price || item.product_price
        : item.product_price;
    },
    // 获取抽奖次数
    getLuckyDrawRestCount(){
      getLuckyDrawCount(this.activeInfo.id).then(res =>{
        this.rest_count = res.data.rest_count || 0
      })
      getLuckyDrawCount(this.loginActiveInfo.id).then(res =>{
        this.login_rest_count = res.data.rest_count || 0
      })
    }
  },
  
  beforeDestory() {
    this.clearTimerId();
  },
};
</script>

<style lang='scss' scoped>
.lucky_draw_wrap,
.recharge_wrap {
  width: 100%;
  min-height: 100vh;
  color: #fff;
  background: linear-gradient(180deg, #22076b 0%, #03000a 100%);
  padding-bottom: 100px;
}
.lucky_draw_wrap{
  background: linear-gradient(180deg, #22076B 0%, #03000A 100%);
}
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 82px;
  z-index: 9999;
  &.fixed {
    position: fixed;
    background: #0b013e;
    background-size: 100% 100%;
    z-index: 1000;
  }
  .center {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    width: 1150px;
    margin: 0 auto;
    .logo {
      width: 258px;
      height: 48px;
      display: block;
      position: relative;
      float: left;
    }
    .flex {
      flex: 1;
      .rit {
        float: right;
      }
    }
    .btn {
      float: left;
      width: 120px;
      height: 35px;
      background: #4a07ff;
      color: #fff;
      border-radius: 32px 32px 32px 32px;
      opacity: 1;
      text-align: center;
      line-height: 35px;
      font-size: 16px;
      margin-left: 35px;
      &:hover {
        background: #6e38ff;
      }
    }
    .personal {
      display: inline-block;
      height: 80px;
      line-height: 80px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      margin-left: 20px;
      position: relative;
      cursor: pointer;
      // width: 100px;
      text-align: center;

      .dropdown-user {
        display: flex;
        // width: 200px;
        height: 100%;
        align-items: center;
        justify-content: center;
        .user-logo {
          width: 48px;
          height: 48px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            border: 2px solid #fff;
          }
        }
        .user-right {
          flex: 1;
          margin-left: 16px;
          text-align: left;
          li {
            font-size: 12px;
            line-height: 1;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            letter-spacing: 1px;
            white-space: nowrap;
            &:first-child {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
}
.recharge_wrap {
  background: url("../../assets/imgs/luckyDraw/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .bg1,
  .bg2 {
    position: absolute;
    z-index: 9;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .main_img {
    position: absolute;
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .btn {
      width: 425px;
      height: 101px;
      margin-top: 32px;
    }
  }
}
.pack_wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: linear-gradient(180deg, #200663 0%, #3b1d8a 100%);
  padding: 60px 0 100px;
  .login_wrap{
    margin-bottom: 60px;
    .login_btn{
      color: #4a07ff;
      cursor: pointer;
    }
    .personal{
      display: flex;
      flex-direction: column;
      .userinfo{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        margin-top: 10px;
        .avator{
          width: 48px;
          height: 48px;
          margin-right: 40px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            border: 2px solid #fff;
          }
        }
      }
    }
  }
  .active_login_info,.active_recharge_info{
    width: 600px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    border: 1px solid #fff;
    // margin: 0 20px;
    margin-bottom: 20px;
    .title, .content{
      font-size: 18px;
      font-weight: bold;
    }
    .content{
      margin-left: 20px;
    }
    .getIcon{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
    }
  }
  .product_list {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    .list_item {
      width: 365px;
      margin: 0 22px;
      .card {
        width: 365px;
        height: 193px;
        position: relative;
        background: url("../../assets/imgs/luckyDraw/pck_bg.png") no-repeat
          center/100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title,
        .average {
          position: absolute;
          top: 9px;
        }
        .title {
          left: 46px;
          font-weight: bold;
        }
        .average {
          right: 10px;
        }
        .price_info {
          font-size: 24px;
          font-weight: bold;
          span {
            color: #fee821;
          }
          .unit {
            color: #fff;
            font-size: 18px;
          }
        }
        .origin {
          font-size: 14px;
          font-weight: bold;
          text-decoration: line-through;
          margin: 5px 0 20px;
          span {
            color: #fee821;
          }
          .unit {
            color: #fff;
            transform: scale(0.2);
          }
        }
        .purchase {
          width: 150px;
          height: 30px;
          line-height: 30px;
          background: #e87002;
          border-radius: 26px;
          font-size: 18px;
          cursor: pointer;
          text-align: center;
        }
      }
      .welfare {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        span {
          color: #fee821;
        }
        &::before {
          content: "";
          display: block;
          width: 20px;
          height: 20px;
          background: url("../../assets/imgs/luckyDraw/gift.png") no-repeat;
          background-size: 100% 100%;
          margin-right: 6px;
        }
      }
    }
  }
}
.lucky_wrap {
  background: linear-gradient(181deg, #3b1d8a 0%, #03000a 100%);
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  .draw_wrap{
    width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 20px;
    border: 1px solid #875CFF;
    border-radius: 20px;
    .left{
      cursor: pointer;
    }
    .right{
      width: 381px;
      background: linear-gradient(180deg, #421C8A 0%, rgba(39,19,104,0.19) 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      box-sizing: border-box;
      .list_header{
        color: #fff;
        font-size: 20px;
        background: url('../../assets/imgs/luckyDraw/list_bg.png') no-repeat;
        background-size: auto 100%;
        padding: 0 50px;
        margin-bottom: 20px;
      }
      .seamless-warp {
        width: 100%;
        height: 400px;
        overflow: hidden;
        cursor: pointer;
        .item{
          li{
            span{
              font-size: 18px;
              .info{
                padding: 0 4px;
                color: #E87002;
              }
            }
          }
        }
      }
      .list_footer{
        color: #fff;
        font-size: 20px;
        width: 229px;
        height: 45px;
        line-height: 45px;
        border-radius: 58px;
        background: linear-gradient(123deg, #8036F7 0%, #5561FF 100%);
        padding: 0 50px;
        margin: 40px 0;
        cursor: pointer;
      }
    }
  }
}
.rule_wrap{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
  .title{
    font-size: 40px;
  }
  .rule{
    margin-top: 20px;
    font-size: 18px;
    width: 1200px;
    font-weight: MicrosoftYaHei, Avenir, Helvetica, Arial, sans-serif;
  }
}
.layer {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 630px;
  height: 350px;
  z-index: 10001;
  background: #1D065B;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
  .layer-title {
    position: relative;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    border-bottom: 1px solid rgba(223, 223, 255, 0.08);
    .title {
      color: rgba(255, 255, 255, 0.6);
    }
    .el-icon-close {
      position: absolute;
      top: 12px;
      right: 12px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.6);
      &:hover {
        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
  .layer-content {
    display: flex;
    padding: 38px 0 0 90px;
    .pay-code {
      position: relative;
      width: 213px;
      height: 213px;
      padding: 16px;
      user-select: none;
      background: url("../../assets/imgs/voucherCenter/qr-border2.png")
        no-repeat top left/cover;

      .qr-code {
        width: 181px;
        height: 181px;
        background-color: rgba($color: #000000, $alpha: 0.8);
        &.loading {
          filter: blur(4px);
          cursor: wait;
        }
        /deep/ img{
          width: 100%;
          height: 100%;
        }
      }
      .scan {
        position: absolute;
        top: 6px;
        left: 8px;
        right: 8px;
        height: 16px;
        background: linear-gradient(
          rgba(0, 180, 255, 0.1),
          rgba(0, 180, 255, 0.6)
        );
        animation: move 2s infinite linear;
      }
      .qr-loading {
        position: absolute;
        width: 32px;
        height: 32px;
        z-index: 1;
        left: 90px;
        top: 90px;
        cursor: wait;
        background-size: 32px 32px;
        background-position: center;
        transform-origin: center;
        // transform: translate(-50%, -50%);
        animation: loading 1s infinite linear;
        background-image: url("../../assets/imgs/voucherCenter/loading.png");
      }
    }
    .pay-info {
      flex: 1;
      display: flex;
      padding-left: 50px;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      .sum {
        text-align: left;
        padding-left: 20px;
        color: #ffdf09;
        font-weight: bold;
        color: #ff6000;
        font-size: 34px;
        /* .integer {
          margin-left: 4px;
          font-size: 32px;
        } */
        .icon {
          font-size: 20px;
          margin-right: 6px;
        }
      }
      .discount{
        padding-left: 20px;
        color: #ff6000;
      }
      .tips {
        margin-top: 36px;
        color: #fff;
      }
      .operate {
        .el-button {
          width: 120px;
          // padding: 10px 25px;
          border-radius: 18px;
          border: none;
          &:hover {
            opacity: 0.9;
          }
          &:active {
            opacity: 0.7;
          }
        }
        .cancel {
          margin-right: 22px;
          background-color: rgba(255, 255, 255, 0.3);
        }
        .comleted {
          background-color: rgba(11, 112, 236, 1);
        }
      }
    }
  }
}
.layer-shadow {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  background-color: rgba($color: #000000, $alpha: 0.3);
}
.payWay{
  width: 160px;
  height: 45px;
  line-height: 45px;
  margin-top: 20px;
  border: 1px solid #792CFF;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  &.selected{
    background: linear-gradient(123deg, #8036F7 0%, #5561FF 100%);
  }
}
.dl_btn{
  position: fixed;
  right: 20px;
  top: 30%;
  width: 200px;
  // height: 70px;
  cursor: pointer;
  z-index: 99999;
}
@keyframes move {
  from {
    top: 6px;
  }
  50% {
    top: 190px;
  }
  to {
    top: 6px;
  }
}
@keyframes loading {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>